module.exports = __webpack_public_path__ + "img/feedback_inactive.5081c4d3.svg";